import React from 'react';
import {
  Box,
  Text,
  Alert,
  AlertIcon,
  List,
  ListItem,
  ListIcon,
  Skeleton,
} from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';
import { useQuery } from '@apollo/client';
import { JobSeeker } from '~/generated';
import { myProfile } from '~/queries';

const IntroductionSuccess: React.FC = () => {
  const { data } = useQuery<{ jobSeekerMe: JobSeeker }>(myProfile);
  const introducedByName = data?.jobSeekerMe?.introducedByName;

  return introducedByName ? (
    <Box maxW="600px">
      <Alert status="success">
        <AlertIcon />
        {introducedByName}さんの紹介コードが適用されました！
      </Alert>
      <Text my={5}>
        以下の条件を10日以内に満たすと、紹介した方と紹介された方の両方に3,000円分のAmazonギフト券がプレゼントされます。
      </Text>

      <List spacing={3} mb={4}>
        <ListItem>
          <ListIcon as={CheckIcon} color="blue.500" />
          理系学部卒として就職予定
        </ListItem>
        <ListItem>
          <ListIcon as={CheckIcon} color="blue.500" />
          2024年に卒業見込み
        </ListItem>
        <ListItem>
          <ListIcon as={CheckIcon} color="blue.500" />
          機械、電気電子、情報、物理、数学、化学のいずれかを専攻
        </ListItem>
        <ListItem>
          <ListIcon as={CheckIcon} color="blue.500" />
          登録から10日以内にプロフィール画像を設定
        </ListItem>
        <ListItem>
          <ListIcon as={CheckIcon} color="blue.500" />
          登録から10日以内に学習内容or学生時代に力を入れたこと、いずれか300文字以上を入力
        </ListItem>
      </List>
    </Box>
  ) : (
    <Skeleton height="20px" />
  );
};

export default IntroductionSuccess;
